// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.color-themes-module {
  margin: 1rem 0;
}

.color-themes-card {
  background: var(--bg-secondary);
  border: 1px solid var(--border-primary);
  border-radius: 12px;
  padding: 1.5rem;
}

.color-themes-title {
  font-size: 1.4rem;
  margin: 0 0 0.5rem;
  color: var(--text-primary);
  font-weight: 700;
}

.color-themes-description {
  margin: 0 0 0.25rem;
  color: var(--text-secondary);
  font-size: 0.85rem;
}

.color-themes-guide-link {
  color: var(--accent-primary);
  text-decoration: underline;
  font-weight: 500;
}

.color-themes-guide-link:hover {
  color: var(--accent-hover);
}

.color-themes-note {
  font-size: 0.8rem;
  color: var(--text-tertiary);
}

.themes-list {
  margin-top: 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

/* Theme row: image left, full entry height */
.theme-row {
  display: flex;
  background: var(--bg-primary);
  border-radius: 10px;
  border: 1px solid var(--border-primary);
  overflow: hidden;
  transition: all 0.25s ease;
  cursor: default;
}

.theme-row:hover {
  border-color: var(--accent-primary);
  box-shadow: 0 2px 12px var(--shadow-primary);
}

.theme-row.copied {
  border-color: var(--success);
}

.theme-content {
  display: flex;
  width: 100%;
  align-items: stretch;
}

/* Image: fills full height of entry */
.theme-image-wrapper {
  flex-shrink: 0;
  width: 160px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.preview-hint {
  display: none;
  position: absolute;
  bottom: 6px;
  right: 6px;
  background: rgba(0, 0, 0, 0.65);
  color: #fff;
  font-size: 0.7rem;
  padding: 3px 8px;
  border-radius: 4px;
  z-index: 2;
  pointer-events: none;
  align-items: center;
  gap: 4px;
}

.theme-image-wrapper:hover .preview-hint {
  display: flex;
}

.theme-image-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--bg-secondary);
}

.theme-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.3s ease;
}

.theme-image-wrapper:hover .theme-image {
  transform: scale(1.08);
}

/* Text section: right of image */
.theme-text-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0.75rem 1rem;
  gap: 0.4rem;
  min-width: 0;
}

.theme-name-string-row {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.3rem;
}

.theme-name {
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--text-primary);
  white-space: nowrap;
  flex-shrink: 0;
  cursor: pointer;
  transition: color 0.2s ease;
}

.theme-name:hover {
  color: var(--accent-primary);
}

.theme-string-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.theme-string {
  font-family: 'Courier New', monospace;
  font-size: 0.8rem;
  padding: 0.3rem 0.5rem;
  background: var(--bg-secondary);
  border-radius: 4px;
  color: var(--text-secondary);
  border: 1px solid var(--border-primary);
  cursor: pointer;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  user-select: all;
  transition: background 0.2s ease;
}

.theme-string:hover {
  background: var(--bg-tertiary);
  color: var(--text-primary);
}

.click-to-copy-hint {
  font-size: 0.75rem;
  color: var(--text-tertiary);
  white-space: nowrap;
  flex-shrink: 0;
}

.copied-indicator {
  color: var(--success);
  font-weight: 600;
  font-size: 0.8rem;
  white-space: nowrap;
  flex-shrink: 0;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(-4px); }
  to { opacity: 1; transform: translateY(0); }
}

/* Image Preview Popup */
.image-preview-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  padding: 2rem;
}

.image-preview-content {
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
  background: var(--bg-primary);
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
}

.image-preview-close {
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  background: var(--bg-secondary);
  border: 1px solid var(--border-primary);
  color: var(--text-primary);
  width: 36px;
  height: 36px;
  border-radius: 50%;
  font-size: 1.3rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  z-index: 10001;
}

.image-preview-close:hover {
  background: var(--bg-tertiary);
  transform: scale(1.1);
}

.image-preview-img {
  max-width: 100%;
  max-height: 80vh;
  object-fit: contain;
  display: block;
  border-radius: 8px;
  cursor: pointer;
}

/* Mobile */
@media (max-width: 680px) {
  .color-themes-card {
    padding: 1rem;
  }

  .theme-content {
    flex-direction: column;
  }

  .theme-image-wrapper {
    width: 100%;
    height: 180px;
  }

  .theme-text-section {
    padding: 0.75rem;
  }

  .theme-name-string-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.4rem;
  }

  .theme-string {
    width: 100%;
  }

  .image-preview-content {
    padding: 1rem;
    max-width: 95vw;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ColorThemes/ColorThemes.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,uCAAuC;EACvC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,uCAAuC;EACvC,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,4CAA4C;AAC9C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,oBAAoB;AACtB;;AAEA,sCAAsC;AACtC;EACE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,+BAA+B;EAC/B,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA,iCAAiC;AACjC;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,iBAAiB;EACjB,sBAAsB;EACtB,+BAA+B;EAC/B,kBAAkB;EAClB,4BAA4B;EAC5B,uCAAuC;EACvC,eAAe;EACf,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,+BAA+B;EAC/B,uCAAuC;EACvC,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA,WAAW;AACX;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;AACF","sourcesContent":[".color-themes-module {\n  margin: 1rem 0;\n}\n\n.color-themes-card {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-primary);\n  border-radius: 12px;\n  padding: 1.5rem;\n}\n\n.color-themes-title {\n  font-size: 1.4rem;\n  margin: 0 0 0.5rem;\n  color: var(--text-primary);\n  font-weight: 700;\n}\n\n.color-themes-description {\n  margin: 0 0 0.25rem;\n  color: var(--text-secondary);\n  font-size: 0.85rem;\n}\n\n.color-themes-guide-link {\n  color: var(--accent-primary);\n  text-decoration: underline;\n  font-weight: 500;\n}\n\n.color-themes-guide-link:hover {\n  color: var(--accent-hover);\n}\n\n.color-themes-note {\n  font-size: 0.8rem;\n  color: var(--text-tertiary);\n}\n\n.themes-list {\n  margin-top: 1.25rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n/* Theme row: image left, full entry height */\n.theme-row {\n  display: flex;\n  background: var(--bg-primary);\n  border-radius: 10px;\n  border: 1px solid var(--border-primary);\n  overflow: hidden;\n  transition: all 0.25s ease;\n  cursor: default;\n}\n\n.theme-row:hover {\n  border-color: var(--accent-primary);\n  box-shadow: 0 2px 12px var(--shadow-primary);\n}\n\n.theme-row.copied {\n  border-color: var(--success);\n}\n\n.theme-content {\n  display: flex;\n  width: 100%;\n  align-items: stretch;\n}\n\n/* Image: fills full height of entry */\n.theme-image-wrapper {\n  flex-shrink: 0;\n  width: 160px;\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n}\n\n.preview-hint {\n  display: none;\n  position: absolute;\n  bottom: 6px;\n  right: 6px;\n  background: rgba(0, 0, 0, 0.65);\n  color: #fff;\n  font-size: 0.7rem;\n  padding: 3px 8px;\n  border-radius: 4px;\n  z-index: 2;\n  pointer-events: none;\n  align-items: center;\n  gap: 4px;\n}\n\n.theme-image-wrapper:hover .preview-hint {\n  display: flex;\n}\n\n.theme-image-container {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--bg-secondary);\n}\n\n.theme-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n  transition: transform 0.3s ease;\n}\n\n.theme-image-wrapper:hover .theme-image {\n  transform: scale(1.08);\n}\n\n/* Text section: right of image */\n.theme-text-section {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 0.75rem 1rem;\n  gap: 0.4rem;\n  min-width: 0;\n}\n\n.theme-name-string-row {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.3rem;\n}\n\n.theme-name {\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  white-space: nowrap;\n  flex-shrink: 0;\n  cursor: pointer;\n  transition: color 0.2s ease;\n}\n\n.theme-name:hover {\n  color: var(--accent-primary);\n}\n\n.theme-string-row {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.theme-string {\n  font-family: 'Courier New', monospace;\n  font-size: 0.8rem;\n  padding: 0.3rem 0.5rem;\n  background: var(--bg-secondary);\n  border-radius: 4px;\n  color: var(--text-secondary);\n  border: 1px solid var(--border-primary);\n  cursor: pointer;\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  user-select: all;\n  transition: background 0.2s ease;\n}\n\n.theme-string:hover {\n  background: var(--bg-tertiary);\n  color: var(--text-primary);\n}\n\n.click-to-copy-hint {\n  font-size: 0.75rem;\n  color: var(--text-tertiary);\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.copied-indicator {\n  color: var(--success);\n  font-weight: 600;\n  font-size: 0.8rem;\n  white-space: nowrap;\n  flex-shrink: 0;\n  animation: fadeIn 0.3s ease;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; transform: translateY(-4px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n/* Image Preview Popup */\n.image-preview-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.85);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n  padding: 2rem;\n}\n\n.image-preview-content {\n  position: relative;\n  max-width: 90vw;\n  max-height: 90vh;\n  background: var(--bg-primary);\n  border-radius: 12px;\n  padding: 1.5rem;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);\n}\n\n.image-preview-close {\n  position: absolute;\n  top: 0.75rem;\n  right: 0.75rem;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-primary);\n  color: var(--text-primary);\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  font-size: 1.3rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  z-index: 10001;\n}\n\n.image-preview-close:hover {\n  background: var(--bg-tertiary);\n  transform: scale(1.1);\n}\n\n.image-preview-img {\n  max-width: 100%;\n  max-height: 80vh;\n  object-fit: contain;\n  display: block;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n/* Mobile */\n@media (max-width: 680px) {\n  .color-themes-card {\n    padding: 1rem;\n  }\n\n  .theme-content {\n    flex-direction: column;\n  }\n\n  .theme-image-wrapper {\n    width: 100%;\n    height: 180px;\n  }\n\n  .theme-text-section {\n    padding: 0.75rem;\n  }\n\n  .theme-name-string-row {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.4rem;\n  }\n\n  .theme-string {\n    width: 100%;\n  }\n\n  .image-preview-content {\n    padding: 1rem;\n    max-width: 95vw;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
